module.exports = __webpack_public_path__ + "assets/ep10.png";